import {Card, CardContent, Typography} from "@mui/material";

export const Affiliate = ({style, maxWidth}) => {
    return (
        <div style={{display:"flex", justifyContent: "center", alignItems:"center", zIndex: 100, margin: 8, textAlign: "center", ...style}}>
            <Card>
                <CardContent sx={{padding: "8px !important"}}>
                <Typography maxWidth={maxWidth ?? 150} fontSize={10} variant="body2" color="text.secondary">
                    This site contains affiliate links for which I may be compensated
                </Typography>
                </CardContent>
            </Card>
        </div>
    )
}